import React from "react";

const shimmerStyle = {
  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
  backgroundSize: "200% 100%",
  animation: "revamp-shimmer 1.5s ease-in-out infinite",
  borderRadius: "8px",
};

const CardSkeleton = () => (
  <div className="revamp-card-skeleton">
    <div className="revamp-card-skeleton__image" style={shimmerStyle} />
    <div className="revamp-card-skeleton__body">
      <div
        className="revamp-card-skeleton__title"
        style={{ ...shimmerStyle, height: "18px", width: "75%", marginBottom: "10px" }}
      />
      <div
        className="revamp-card-skeleton__text"
        style={{ ...shimmerStyle, height: "14px", width: "100%", marginBottom: "8px" }}
      />
      <div
        className="revamp-card-skeleton__text"
        style={{ ...shimmerStyle, height: "14px", width: "60%", marginBottom: "12px" }}
      />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ ...shimmerStyle, height: "14px", width: "30%" }} />
        <div style={{ ...shimmerStyle, height: "24px", width: "20%", borderRadius: "12px" }} />
      </div>
    </div>
  </div>
);

const SectionSkeleton = () => (
  <div className="revamp-section-skeleton">
    <div
      style={{ ...shimmerStyle, height: "28px", width: "200px", marginBottom: "20px" }}
    />
    <div className="revamp-products-grid">
      {Array.from({ length: 4 }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  </div>
);

const ProductSkeleton = ({ sections = 3 }) => (
  <div className="revamp-skeleton-container">
    <div style={{ ...shimmerStyle, height: "48px", width: "100%", marginBottom: "32px", borderRadius: "12px" }} />
    {Array.from({ length: sections }).map((_, i) => (
      <SectionSkeleton key={i} />
    ))}
  </div>
);

const DetailsSkeleton = () => (
  <div className="revamp-details-skeleton">
    <div style={{ ...shimmerStyle, height: "280px", width: "100%", marginBottom: "24px", borderRadius: "16px" }} />
    <div style={{ ...shimmerStyle, height: "32px", width: "60%", marginBottom: "12px" }} />
    <div style={{ ...shimmerStyle, height: "18px", width: "40%", marginBottom: "24px" }} />
    <div style={{ ...shimmerStyle, height: "1px", width: "100%", marginBottom: "24px" }} />
    {Array.from({ length: 4 }).map((_, i) => (
      <div key={i} style={{ marginBottom: "20px" }}>
        <div style={{ ...shimmerStyle, height: "20px", width: "35%", marginBottom: "10px" }} />
        <div style={{ ...shimmerStyle, height: "14px", width: "100%", marginBottom: "6px" }} />
        <div style={{ ...shimmerStyle, height: "14px", width: "85%", marginBottom: "6px" }} />
        <div style={{ ...shimmerStyle, height: "14px", width: "70%" }} />
      </div>
    ))}
  </div>
);

export { ProductSkeleton, DetailsSkeleton, CardSkeleton };
export default ProductSkeleton;
